'use strict';

var controller = new ScrollMagic.Controller();

const modal = document.querySelector('.price-modal');
const btnopenModal = document.querySelector('.price-modal__open');
const btncloseModal = document.querySelector('.price-modal__close');

const openModal = function(){
  modal.classList.add('modal-open');
}

// btnopenModal.addEventListener('click', openModal);

// Click function for show the Modal

$(".cus-show").on("click", function(){
  $(".cus-mask").addClass("active");
});

// Function for close the Modal

function closeModal(){
  $(".cus-mask").removeClass("active");
}

// Call the closeModal function on the clicks/keyboard

$(".cus-close, .cus-mask").on("click", function(){
  closeModal();
});

$(document).keyup(function(e) {
  if (e.keyCode == 27) {
    closeModal();
  }

});

$(document).ready(function(){
  $('#videoThumbPlaceholder').click(function () {
    var video = '<iframe src="' + $(this).attr('data-video') + '"></iframe>';
    $(this).replaceWith(video);
  });
});
$(".imageWrapperPlay>span").click(function () {
  var $this = $(this);
  var $parent = $this.closest('.videoContainers');
  var $video = $parent.find('video');
  $video.toggleClass("display");
  setTimeout(function () {
    $video.get(0).play();
  },100);
});
if ($(window).width() > 767) {
  $(".img_producto_container")
  // tile mouse actions
  .on("mouseover", function () {
    $(this)
    .children(".img_producto")
    .css({ transform: "scale(" + $(this).attr("data-scale") + ")" });
  })
  .on("mouseout", function () {
    $(this)
    .children(".img_producto")
    .css({ transform: "scale(1)" });
  })
  .on("mousemove", function (e) {
    $(this)
    .children(".img_producto")
    .css({
      "transform-origin":
      ((e.pageX - $(this).offset().left) / $(this).width()) * 100 +
      "% " +
      ((e.pageY - $(this).offset().top) / $(this).height()) * 100 +
      "%"
    });
  });


}

if ($(window).width() < 767) {

  $('.innerSliderThumb a').click( function(e) {
    e.preventDefault();
    $('.mainSliderProduct').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 0);
    $(window).scrollTop(0);
  })


}


$(".menuContainer .sub_menu_item li a").hover(function(){
  var ClassI = $(this).data("class");
  $(this).parents(".sub_menu_item").find("a").removeClass("active");
  $(this).addClass("active");
  $(this).parents(".subMenu").find(".logosContainerSubMenu > div").hide();
  if($(this).parents(".subMenu").find("#sub_" + ClassI).length != 0){
    $("#sub_" + ClassI).show();
  }else{
    $(this).parents(".subMenu").find(".logosContainerSubMenu > div#sub_default").show();
  }
});

$(".menuContainer > ul > li").each(function(){
  if($(this).find(".sub_menu_item li a.active").length == 1){
    $(this).find(".sub_menu_item li a.active").parents(".subMenu").find(".logosContainerSubMenu > div").hide();
    var CCurrnt = $(this).find(".sub_menu_item li a.active").data("class");
    $("#sub_" + CCurrnt).show();
  }else{
    $(this).find(".sub_menu_item li:first-child a").addClass("active");
  }
});

//-----------------------------------------------------------------------------------------
//
//
// May 19 2022
//
//
//-----------------------------------------------------------------------------------------
//
//-----------------------------------------------------------
//
// Helper Functions
//
//-----------------------------------------------------------
//
//--------------------------------
// Debounce
//--------------------------------
//
function _debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this, args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

//--------------------------------
// Is Minimum Browser Width
//--------------------------------
//
function _isMinBrowserWidth(width) {

  // Return Boolean
  //
  return window.matchMedia("(min-width: " + width + "px)").matches;
}

$(document).ready(function () {

  //-----------------------------------------------------------
  //
  // Accordion - Filter Mobile
  //
  //-----------------------------------------------------------
  //
  (function () {
    var $el = $('.accordionFilterMobile');
    var $btn = $('.accordionFilterMobileBtn', $el);
    var $content = $('.accordionFilterMobileContent', $el);

    $btn.click(function () {
      if ($el.hasClass('active')) {
        $content.slideUp(500);
        $el.removeClass('active');
      } else {
        $el.addClass('active');
        $content.slideDown(500);
      }
    });

    //--------------------------------
    // Resize
    //--------------------------------
    //
    $(window).on('resize', _debounce(function () {
      if (_isMinBrowserWidth(768)) {
        $el.removeClass('active');
        $content.css({'display': ''});
      }
    }, 250));
  })();

  //-----------------------------------------------------------
  //
  // Compare tags to list
  //
  //-----------------------------------------------------------
  //
  (function () {

    $(document).ajaxComplete(function (event, request, settings) {

      //--------------------------------
      // Selectors
      //--------------------------------
      //
      var $el = $('.comparable-container');
      var $td = $('table.comparison-table td.product-table__cell:contains("Tags")', $el);
      var $tbody = $td.closest('tbody');
      var $p = $('p', $tbody);
      var $addToCartBtn = $('.add-to-cart-wrap', $el);
      var $removeBtn = $('.remove-from-compare', $el);

      //--------------------------------
      // Arrays
      //--------------------------------
      //
      var SPEC_TITLE = [];
      var SPEC_OBJ = [];

      //--------------------------------
      // Convert text to SPEC_OBJ array
      //--------------------------------
      //
      $p.each(function () {
        var $this = $(this);
        var $a = $('a', $this);
        var LIST = [];

        $a.each(function () {
          var $this = $(this);
          var VALUE = $this.text();
          var SPLIT_VALUE = VALUE.split('_');

          // Filter unwanted items
          //
          if (SPLIT_VALUE[0].indexOf("New Watch Novelties") >= 0 ||
              SPLIT_VALUE[0].indexOf("Year") >= 0) {
            return;
          }

          // Push the items' key to SPEC_TITLE array
          //
          if (SPEC_TITLE.indexOf(SPLIT_VALUE[0]) === -1) {
            SPEC_TITLE.push(SPLIT_VALUE[0])
          }

          // Push the values to LIST array
          //
          LIST.push(VALUE);
        });

        // Convert LIST array to an object
        //
        LIST = Object.fromEntries(LIST.map(s => s.split('_')));

        // Push the List object to SPEC_OBJ array
        //
        SPEC_OBJ.push(LIST);
      });

      //--------------------------------
      // Compare between the SPEC_TITLE
      // and the SPEC_OBJ, then add
      // the missing entries
      // to the SPEC_OBJ
      //
      // Then sort the SPEC_OBJ and push
      // to the SORTED_SPEC_OBJ
      //--------------------------------
      //
      SPEC_OBJ.map(function (obj) {
        var ABSENT = [];
        var SORTED_OBJ = {};

        ABSENT = SPEC_TITLE.filter(function (key) {
          return Object.keys(obj).indexOf(key) === -1;
        });

        ABSENT.map(function (key) {
          return obj[key] = 'N/A';
        });
      });

      //--------------------------------
      //
      //--------------------------------
      //
      $tbody.empty().addClass('comparable-spec');

      //--------------------------------
      //
      //--------------------------------
      //
      SPEC_TITLE.forEach(function (key) {
        $tbody.append('<tr><td class="product-table__cell comparable-spec-title">' + key + '</td></tr>');
      });

      //--------------------------------
      //
      //--------------------------------
      //
      var $newTr = $('tr', $tbody);

      $newTr.each(function () {
        var $this = $(this);
        var TITLE = $this.text();

        SPEC_OBJ.forEach(function (obj, index) {
          return $this.append('<td class="product-table__cell" data-item-id="' + index + '">' + obj[TITLE] + '</td>');
        });
      });

      //--------------------------------
      //
      //--------------------------------
      //
      $el.animate({'opacity': 1});

      //--------------------------------
      //
      //--------------------------------
      //
      $removeBtn.each(function (index) {
        var $this = $(this);
        $this.click(function () {
          $('[data-item-id=' + index + ']').remove();
        });
      });
    });
  })();
});

//-----------------------------------------------------------
//
// History Scroll
//
//-----------------------------------------------------------
//

$(document).ready(function () {
  (function () {
    var $els = $('div.reversewrows');

    $els.each(function () {
      var $this = $(this);

      console.log('hit');

      new ScrollMagic.Scene({
        triggerElement: $this,
        triggerHook: 0.8,
      })
          .setClassToggle($this, "active") // add class to reveal
          .addTo(controller);
    });
  })();
});

//-----------------------------------------------------------------------------------------
//
//
// Copy URL to Clipboard
//
//
//-----------------------------------------------------------------------------------------
//
$(document).on('click', '.copyUrlToClipboard', function (e) {
  e.preventDefault();
  var inputc = document.body.appendChild(document.createElement("input"));
  inputc.value = window.location.href;
  inputc.focus();
  inputc.select();
  document.execCommand('copy');
  inputc.parentNode.removeChild(inputc);
  alert("URL Copied.");
});


